import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import Tab from "@mui/material/Tab";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";

import NavigationBack from "src/components/Navigation";
import UserTitle from "../../components/UserTitle";
import { getUserInfo } from "../../api/user.deprecated";
import { StyledTabs } from "../../components/Base";

const MemberEditNavigation = ({ match, history, onGoBack }) => {
  const { t } = useTranslation();
  const { crewId, userId, pageId } = match.params;

  const [user, setUser] = useState();
  useEffect(() => {
    (async () => {
      const userInfo = await getUserInfo(userId);
      setUser(userInfo);
    })();
  }, [userId]);
  const navigateTo = (_, value) => {
    const subpage = v(value);
    // Use replace to avoid creating history entries for tab changes
    history.replace(`/crew/${crewId}/members/${userId}/edit/${subpage}`);
  };

  const pages = ["properties", "aircraft"];
  const titles = [t("member_properties"), t("aircraft")];

  const rv = (subpage) => pages.indexOf(subpage);
  const v = (i) => pages[i];

  // member-edit also routes subpages that are not tabs (aircraft-and-specialization), so the
  // lookup can miss. MUI wants `false` - not -1 - to mean "no tab selected", and an absent
  // title must drop the heading rather than render an empty one (CREW-564).
  const selectedIndex = rv(pageId);
  const selectedTab = selectedIndex === -1 ? false : selectedIndex;
  const title = titles[selectedIndex];
  return (
    <>
      {user && (
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: { xs: 0, sm: 2 },
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              minWidth: 0,
            }}
          >
            <NavigationBack onBeforeGoBack={onGoBack} />
            {/* The aircraft title wraps on narrow viewports (CREW-558), where the theme's
                3rem h4 line-height would leave a gaping block; German compounds also need an
                explicit break opportunity, and minWidth: 0 lets it shrink inside the flex row. */}
            {title && (
              <Typography
                variant="h4"
                sx={(theme) => ({
                  minWidth: 0,
                  overflowWrap: "anywhere",
                  lineHeight: { xs: 1.4, md: theme.typography.h4.lineHeight },
                })}
              >
                {title}
              </Typography>
            )}
          </Box>
          <UserTitle id={`${user.id}`} name={user.name} email={user.email} />
        </Box>
      )}

      <StyledTabs
        variant="fullWidth"
        value={selectedTab}
        indicatorColor="primary"
        onChange={navigateTo}
        sx={{
          // fullWidth pins each tab to half the viewport, so the long aircraft label (CREW-558)
          // has to wrap on phones. MUI Tab already wraps on spaces, but German compounds offer
          // none - without overflowWrap they would be clipped by the tab's overflow: hidden.
          "& .MuiTab-root": {
            px: { xs: 1, sm: 2 },
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
            lineHeight: 1.3,
            overflowWrap: "anywhere",
          },
        }}
      >
        {/* describeChild: without it MUI copies the tooltip onto the Tab as aria-label, which
            REPLACES the tab's own name - screen readers then announce the hint and never the
            tab (CREW-563). As a description it supplements the label instead. */}
        <Tooltip title={t("properties_hint")} describeChild>
          <Tab label={t("properties")} />
        </Tooltip>
        <Tooltip title={t("aircraft_authorization_hint")} describeChild>
          <Tab label={t("aircraft")} />
        </Tooltip>
      </StyledTabs>
    </>
  );
};

export default MemberEditNavigation;
